/**
 * Builds a wa.me deep link, optionally prefilled with a message.
 *
 * Party and lead phone numbers are entered by hand and arrive with spaces,
 * dashes and sometimes a country code, so strip to digits and assume India for
 * bare 10-digit numbers.
 */
export const whatsappUrl = (phone: string, text?: string): string => {
    const digits = phone.replace(/\D/g, '');
    const withCc = digits.length === 10 ? `91${digits}` : digits;
    const query = text ? `?text=${encodeURIComponent(text)}` : '';
    return `https://wa.me/${withCc}${query}`;
};
